import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { listMyRunSkills } from "../api/getRunSkills";

/**
 * The user's own skills, for the composer's slash typeahead. Keyed by
 * `queryKeys.skills.mine()` so it shares the skills manager's cache — a skill
 * created or deleted in Settings shows up here without a refetch. Disabled
 * skills are filtered out (via `select`, so the shared cache is untouched): a
 * skill turned off in the manager can't be slash-invoked or auto-selected.
 */
export function useMyRunSkills() {
  return useQuery({
    queryKey: queryKeys.skills.mine(),
    queryFn: listMyRunSkills,
    staleTime: 2 * 60_000,
    select: (skills) => skills.filter((s) => s.enabled),
  });
}
